export default __webpack_public_path__ + "static/SectionTwo_02_02@2x-588ba60699688f786e6774c7a239790e.webp";